"use client";

import { motion } from "framer-motion";
import Image from "next/image";

interface PageHeroProps {
  title: string;
  subtitle: string;
  image: string;
  superText?: string; // Opsional (Teks kecil di atas judul)
}

export default function PageHero({
  title,
  subtitle,
  image,
  superText = "KinKen Kost Elite", // Default value
}: PageHeroProps) {
  return (
    <section className="relative h-[60vh] min-h-[400px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <Image
          src={image}
          alt={title}
          fill
          className="object-cover"
          priority // Agar gambar dimuat duluan (LCP Optimization)
        />
        {/* Overlay Gelap */}
        <div className="absolute inset-0 bg-black/50" />
      </div>

      {/* Konten Text */}
      <div className="relative z-10 text-center px-6">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-brand-gold text-xs font-bold tracking-[0.25em] uppercase block mb-4"
        >
          {superText}
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="font-serif text-4xl md:text-6xl text-white mb-6 drop-shadow-md"
        >
          {title}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-gray-200 font-light text-lg max-w-2xl mx-auto drop-shadow-sm"
        >
          {subtitle}
        </motion.p>
      </div>
    </section>
  );
}
